import Vue from "vue";
import Vuex from "vuex";
import BlackjackEngine from "@blackjacktrainer/blackjack-engine";
import game from "./game";
import defaultTableValue from "./default-table";
import { translateHint } from "./utils";

Vue.use(Vuex);

const settings = {
  animationDelay: 200,
  deckCount: 3,
  allowSurrender: false,
  allowLateSurrender: false,
  checkDeviations: false,
  gameMode: "default",
  cardCounterType: null
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    game,
    activeTable: defaultTableValue,
    hint: "SURRENDER"
  },
  mutations: {
    changeGameState(state, gameStatePayload) {
      Vue.set(state, "game", gameStatePayload);
    },

    changeHint(state, payload) {
      const hint =
        !state.activeTable[payload.x] ||
        !state.activeTable[payload.x][payload.y]
          ? "STAND"
          : state.activeTable[payload.x][payload.y].value;

      Vue.set(state, "hint", translateHint(hint));
    },

    changeTableState(state, payload) {
      Vue.set(
        state,
        "activeTable",
        JSON.parse(JSON.stringify(defaultTableValue))
      );
      if (
        !state.activeTable[payload.x] ||
        !state.activeTable[payload.x][payload.y]
      )
        return false;

      state.activeTable[payload.x][payload.y].active = true;
    }
  },
  getters: {
    hint: state => {
      return state.hint;
    },
    charts: state => {
      return state.activeTable;
    },
    game: state => {
      return state.game;
    },
    gameShoe: state => {
      return state.game.shoe;
    },
    getAvailableCards: state => {
      return game.shoe.cards;
    },
    lastCardCounterValue: state => {
      return state.game.state.lastCardCounterValue;
    },
    getDeckCount: state => {
      return state.game.state.deckCount;
    },
    getMaxCards: state => {
      return state.game.shoe.maxCards;
    },
    cardCounter: state => {
      return state.game.state.counter;
    },
    gameState: state => {
      return state.game.state;
    },
    dealer: state => {
      return state.game.dealer;
    },
    player: state => {
      return state.game.player;
    },
    shoe: state => {
      return state.game.shoe;
    },
    getGameStep: state => {
      return state.game.state.step;
    },
    remainingCards: state => {
      return state.game.shoe.cards;
    },
    dealerHands: state => {
      return state.game.dealer.hands;
    },
    playerHands: state => {
      return state.game.player.hands;
    },
    dealerCards: state => {
      return state.game.dealer.hands.reduce((acc, elem) => {
        acc.push(...elem.cards);
        return acc;
      }, []);
    },
    playerCards: state => {
      return state.game.player.hands.reduce((acc, elem) => {
        acc.push(...elem.cards);
        return acc;
      }, []);
    },
    playerTotalCardsValue: state => {
      return state.game.player.hands.reduce((acc, elem) => {
        acc += elem.cardTotal;
        return acc;
      }, 0);
    },
    dealerLastCard: state => {
      const dealerCards = state.game.dealer.hands.reduce((acc, elem) => {
        acc.push(...elem.cards);
        return acc;
      }, []);
      if (dealerCards.length) {
        return dealerCards[dealerCards.length - 1].rank;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js